import React, { useEffect, useRef } from 'react';
import { SiSpringboot, SiPostgresql } from 'react-icons/si';
import { FaJava, FaReact, FaDocker, FaArrowRight } from 'react-icons/fa';
import './style.css';

const featuredTech = [
  { name: 'Spring Boot', Icon: SiSpringboot, color: '#6db33f' },
  { name: 'Java', Icon: FaJava, color: '#f89820' },
  { name: 'React', Icon: FaReact, color: '#61dafb' },
  { name: 'PostgreSQL', Icon: SiPostgresql, color: '#336791' },
  { name: 'Docker', Icon: FaDocker, color: '#2496ed' }
];

const techGroups = [
  {
    label: 'Backend',
    items: ['Java', 'Spring Boot', 'Spring Framework', 'Microservices', 'REST', 'Maven', 'JUnit']
  },
  {
    label: 'Frontend',
    items: ['React', 'JavaScript', 'TypeScript', 'HTML5', 'CSS3']
  },
  {
    label: 'Datenbanken',
    items: ['PostgreSQL', 'MySQL']
  },
  {
    label: 'DevOps & Cloud',
    items: ['Docker', 'AWS', 'Git']
  },
  {
    label: 'Tools',
    items: ['Node.js']
  }
];

const ServicesSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const sectionNode = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      },
      { threshold: 0.08, rootMargin: '60px 0px' }
    );
    if (sectionNode) observer.observe(sectionNode);
    return () => {
      if (sectionNode) observer.unobserve(sectionNode);
    };
  }, []);

  return (
    <section id="what-to-do" className="what-to-do-section" ref={sectionRef}>
      <div className="what-to-do-inner">
        <div className="tech-section-header">
          <h2 className="tech-section-title">
            Ich arbeite mit modernen Technologien
          </h2>
          <span className="tech-section-underline" aria-hidden />
        </div>

        <div className="tech-cards-grid">
          {featuredTech.map(({ name, Icon, color }) => (
            <div key={name} className="tech-card">
              <span className="tech-card-icon" style={{ color }}>
                <Icon />
              </span>
              <span className="tech-card-name">{name}</span>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="tech-expand-btn"
          onClick={() => {
            const el = document.getElementById('tech-full-stack');
            el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
        >
          Alle Technologien
          <FaArrowRight aria-hidden />
        </button>

        <div id="tech-full-stack" className="tech-groups">
          {techGroups.map((group) => (
            <div key={group.label} className="tech-group">
              <h3 className="tech-group-label">{group.label}</h3>
              <div className="tech-group-items">
                {group.items.map((item) => (
                  <span key={item} className="tech-item">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
